import PersonalSetting from './index.vue';

export default PersonalSetting;
